import { buildOpenChoreoTheme } from './buildOpenChoreoTheme';
import { darkTokens } from './tokens';

export const openChoreoDarkTheme = buildOpenChoreoTheme(darkTokens);
